import React from 'react'
import styled from 'styled-components'
import LeftBarTop from './LeftBarTop'
import LeftBarBottom from './LeftBarBottom'
import { UIStyles } from '../../theme'
import { withCurrentRoute } from '../HOCComponents/withCurrentRoute'

export const LeftBarWrapper = styled.div`
  position: fixed;
  left: 0;
  bottom: 0;
  top: 60px;
  background-color: ${UIStyles.deepblueColor3};
  width: 60px;
  display: flex;
  flex-direction: column;
  border-right: 1px solid ${UIStyles.mintBorder};
  /* Above the panels and map controls beside it (z 5 at most) and below the LAYI chat (9), which
     covers it when the chat takes the whole width. */
  z-index: 8;
`

const ComponentsWrapper = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`

function LeftBar(props) {
  const { isSampleImage, isBiLabs, isAccounts, isCropMaster, isChat } = props.currentLocation
  if (isSampleImage || isBiLabs || isAccounts || isCropMaster || isChat) return null

  return (
    <LeftBarWrapper>
      <ComponentsWrapper>
        <LeftBarTop />
        <LeftBarBottom />
      </ComponentsWrapper>
    </LeftBarWrapper>
  )
}

export default withCurrentRoute(LeftBar)
